'use client';

import Image from "next/image";
import s from './AllModules.module.scss';
import Introduction from "../introduction";
import Full from "../full";
import FlexImagesComponent from "../flexImages";
import QuoteComponent from "../quote";
import GalleryComponent from "../gallery";
import SideTextComponent from "../sideText";
import CreditsComponent from "../credits";
import RelatedComponent from "../related";

interface DataProps {
    data: any;
}

export default function ModulePrint({ data }: DataProps) {
    
    return (
        <>
            {data && data.map((item: any, index: any) => {
                if(item._type == 'module.introduction'){
                    return (
                        <section className={s.sectionIntroduction} key={`module-${index}-${item._type}`}>
                            <Introduction data={item} />
                        </section>
                    )
                } else if(item._type == 'module.full'){
                    return (
                        <section className={s.sectionFull} key={`module-${index}-${item._type}`}>
                            <Full data={item} />
                        </section>
                    )
                } else if(item._type == 'module.flexImages'){
                    return (
                        <section className={s.sectionFlexImages} key={`module-${index}-${item._type}`}>
                            <FlexImagesComponent data={item} />
                        </section>
                    )
                } else if(item._type == 'module.quote'){
                    return (
                        <section className={s.sectionQuote} key={`module-${index}-${item._type}`}>
                            <QuoteComponent data={item} />
                        </section>
                        
                    )
                } else if(item._type == 'module.gallery'){
                    return (
                        <section className={s.sectionGallery} key={`module-${index}-${item._type}`}>
                            <GalleryComponent data={item} />
                        </section>
                    )
                } else if(item._type == 'module.sideText'){
                    return (
                        <section className={s.sectionSideText} key={`module-${index}-${item._type}`}>
                            <SideTextComponent data={item} />
                        </section>
                    )
                } else if(item._type == 'module.credits'){
                    return (
                        <section className={s.sectionCredits} key={`module-${index}-${item._type}`}>
                            <CreditsComponent data={item} />
                        </section>
                        
                    )
                } else if(item._type == 'module.related'){
                    return (
                        <section className={s.sectionRelated} key={`module-${index}-${item._type}`}>
                            <RelatedComponent data={item} />
                        </section>
                    )
                }
            })}
        </>
    );
}